import { render, staticRenderFns } from "./FeatureOptionPricingRow.vue?vue&type=template&id=8bf0b9a2&scoped=true"
import script from "./FeatureOptionPricingRow.vue?vue&type=script&lang=js"
export * from "./FeatureOptionPricingRow.vue?vue&type=script&lang=js"
import style0 from "./FeatureOptionPricingRow.vue?vue&type=style&index=0&id=8bf0b9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0b9a2",
  null
  
)

export default component.exports